import "./RegisterQueue.scss"
import 'moment/locale/id';

import { KeyboardDoubleArrowRight } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid } from "@mui/material";
import { kfIconGroup,patternBackground } from "assets/images";
import { isStr, parseNumberToPath, parseQueue, youtubeParser } from "common/utils";
import FullScreenPage from "components/fullscreen";
import { onMessage } from "firebase/messaging";
import { getFirebaseToken, messaging } from "foregroundMessage";
import { LastQueue } from "models/last-queue.model";
import { NextQueue } from "models/next-queue.model";
import { RunningText } from "models/running-text.model";
import  moment from "moment";
import React, { ReactNode } from "react";
import Marquee from "react-fast-marquee";
import Moment from "react-moment";
import { connect } from "react-redux";
import MasterMessengerService from "services/master-messenger.service";
import QueueService from "services/queue.service";
import { ApplicationState } from "store";
import { ConfigState } from "store/config/config.reducer";
import YtPlayer from 'youtube-player';


const queueService = new QueueService();
const InfoCounterNumber = (props: { title: any, counter: string | ReactNode }) => (
    <div className='flex flex-col justify-center pt-[1.1rem]'>
        <div className='text-[#9D9DA2] text-4xl font-extrabold text-center whitespace-nowrap'>
            {props.title}
        </div>
        {typeof props.counter === "string" ?
            (<div className='font-bold text-[12rem] leading-[1] text-[#3A3A3C] text'>
                {props.counter}
            </div>) :
            props.counter
        }
    </div>
)
interface IStateProps {
    configState: ConfigState;
}
const mapStateToProps = (state: ApplicationState): IStateProps => ({
    configState: state.configState
})
interface OwnProps {
    withFcm: boolean
}
type IProps = IStateProps & OwnProps;

interface PlayingSoundModel {
    counterNumber: string;
    counterName: string;
    lastModified: string;
}
interface RegisterState {
    showDialogPermission: boolean;
    permissionAutoPlay: boolean;
    listNextQueue: NextQueue[];
    listRunningText: RunningText[];
    objectAudios: Record<string, any>;
    currentPlaying: PlayingSoundModel;
    isPlayingSound: boolean;
    loadingGetQueue: boolean;
    hasUpdatedState: boolean;
}

class RegisterQueue extends React.Component<IProps, RegisterState> {
    periodicInterval: string | number | NodeJS.Timer | undefined;
    pendingToPlay: PlayingSoundModel[] = [];
    messengerService = new MasterMessengerService();
    state: Readonly<RegisterState> = {
        showDialogPermission: false,
        permissionAutoPlay: false,
        listNextQueue: [],
        listRunningText: [],
        objectAudios: {},
        currentPlaying: {} as PlayingSoundModel,
        isPlayingSound: false,
        loadingGetQueue: false,
        hasUpdatedState: false,
    }

    playSoundByPath(path: string[], totalPath: number): void {
        let canPlaying = false;
        try {
            const indexNum = totalPath - 1;
            const ad = document.querySelector(`#${path[indexNum]}`) as HTMLAudioElement;
            const keyEnd = "onended";

            if (!ad) 
                return;

            ad.muted = false;
            if (path.length === totalPath) {
                this.setState({isPlayingSound: true})
            }
            ad.play()
                .then(() => {
                    canPlaying = true;
                })
                .catch((error) => {
                    this.state.isPlayingSound && this.setState({isPlayingSound: false});
                    if (!canPlaying) {
                        this.setState({showDialogPermission: true})
                    }
                })

            ad[keyEnd] = (e) => {
                if (!canPlaying)
                    return;
                console.log(
                    "soundInPlaying:",indexNum, 
                    ", pendingToPlay:",this.pendingToPlay.length,
                    ", isPlayingSound:", this.state.isPlayingSound
                );
                const listPending = this.pendingToPlay;
                if (indexNum > 0) {
                    this.playSoundByPath(path, indexNum);
                } else if (listPending.length > 0) {
                    setTimeout(() => this.shiftAndPlaySound(), 1000);
                } else {
                    console.log("set false isplaying")
                    this.setState({isPlayingSound: false})
                }
            }
        } catch(error) {
            if (this.state.isPlayingSound) {
                this.setState({isPlayingSound: false})

            }
        }
    }

    async playSound(queue = '', loket = ''):Promise<void> {
        const audioPath: any[] = [];
        audioPath.push('intro', 'patientWithNumber');
    
        const queueArr = parseQueue(queue);
        queueArr.forEach(q => {
            if (isStr(q)) {
                [...q].forEach((key: string) => {
                    audioPath.push(`alphabet${key.toUpperCase()}`);
                })
            } else {
                parseNumberToPath(Number(q), audioPath);
            }
        })
        
        if (loket && loket !== '') {
            audioPath.push('toCounter');
            const loketNumber = Number(`${loket}`.replace(/\D/g, ''));
            parseNumberToPath(loketNumber, audioPath);
        }
        const listAudioPath = [...audioPath].reverse();
        this.playSoundByPath(listAudioPath, audioPath.length);
    }

    fullscreenPage() {
        document.querySelector(`#register-queue`)?.requestFullscreen();
    }

    playSoundAndFullscreen = () => {
        this.setState({
            showDialogPermission: false,
            permissionAutoPlay: true,
            hasUpdatedState: true
        })
        this.pendingToPlay = [];
        console.log('masuk sni')
    }

    async loadAllAudios(): Promise<void> {
        const objectAudios: Record<string, any> = {};
        const sound: Record<string, any> =  await import("../assets/sounds/index");
        Object.keys(sound).forEach(key => {
            objectAudios[key] = sound[key];
        })
        this.setState({objectAudios});
    }

    async  shiftAndPlaySound(): Promise<void>{
        if (!this.state.permissionAutoPlay)
            return;

        const listPendingCopied = this.pendingToPlay.map(e => ({...e}));
        const toBePlay = listPendingCopied.shift();
        if (toBePlay) {
            await this.setState(state => ({
                ...state,
                currentPlaying: toBePlay
            }));

            this.pendingToPlay = listPendingCopied;

            
            if (toBePlay?.counterName !== '' && toBePlay?.counterNumber !== '') {
                this.playSound(toBePlay?.counterNumber, toBePlay?.counterName);
            }
        }
    }

    checkAndPushToPendingToPlay(data: LastQueue) {
        const counterName = `${data?.counterName}`.toLowerCase()
                        .replace("loket", '')
                        .trim();

        const {lastModified, counterNumber} = data;
        if (lastModified === this.state.currentPlaying?.lastModified) 
            return;

        const isInPendingToPlay = this.pendingToPlay.find(e => 
            e.counterName === counterName &&
            e.counterNumber === counterNumber &&
            e.lastModified === lastModified
        )

        if (isInPendingToPlay)
            return;

        const {isPlayingSound} = this.state;
        this.pendingToPlay.push(
            {
                counterName,
                counterNumber,
                lastModified
            }
        )

        if (!isPlayingSound) {
            this.shiftAndPlaySound();
        }
    }

    async getLastQueue(): Promise<void> {
        await queueService.getLastQueue(`${this.props.configState.outletId}`).then(
            ({data}) => {
                if (data && data.result) {
                    const res = data.result;
                    this.checkAndPushToPendingToPlay(res);
                } else {
                    const currentDate = moment();
                    const lastDate = this.state.currentPlaying?.lastModified;

                    if (lastDate && lastDate !== '' && !currentDate.isSame(lastDate, 'day')) {
                        const resetQueue = {
                            counterName: '',
                            counterNumber: '',
                            lastModified: ''
                        } as PlayingSoundModel;
                        this.setState({currentPlaying: resetQueue});
                    }
                }
            },
            (error) => {
                this.setState({loadingGetQueue: false});
            }
        )
    }


    intervalMethod(isRefresh = true) {
        isRefresh && this.getLastQueue();
        queueService.nextQueue(`${this.props.configState.outletId}`).then(({data}) => {
            this.setState({listNextQueue: data.result});
        })
    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<RegisterState>, snapshot?: any): void {
        if (this.state.hasUpdatedState && !prevState.hasUpdatedState) {
            this.fullscreenPage()
        }
    }

    componentDidMount(): void {
        if (this.props.withFcm) {
             this.subscribeNotif();
        } else {
            this.periodicInterval = setInterval(() => !this.state.loadingGetQueue && this.intervalMethod(), 3000);
        }
        
        this.fullscreenPage();
        this.loadAllAudios();

        (window as any).playSound = this.playSound;
        queueService.nextQueue(`${this.props.configState.outletId}`).then(({data}) => {
            this.setState({listNextQueue: data.result});
        })
        queueService.getRunningText(`${this.props.configState.outletId}`).then(({data}) => {
            this.setState({listRunningText: data.result});
        })
        queueService.getVideoUrl(`${this.props.configState.outletId}`).then(({data}) => {
           if (data.result) {
                const activeVideos = data.result.filter( e => e.status);
                if (activeVideos.length > 0 && Object.keys(activeVideos[0]).length > 1) {
                    const v = activeVideos[0];
                    const idYt = youtubeParser(v.url);
                    if (idYt) {
                        // eslint-disable-next-line new-cap
                        const player = YtPlayer('video-player', {
                            playerVars: {
                                playlist: `${idYt}`,
                                loop: 1,
                            }
                        });
                        player.playVideo();
                        player.setLoop(true);
                        player.mute()
                    }
                }
           }
        });
        this.setState({permissionAutoPlay: true})
        this.intervalMethod();
    }

    componentWillUnmount(): void {
        clearInterval(this.periodicInterval)
    }

    /**
     * 
     */
    async subscribeNotif() {
        Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
                getFirebaseToken()
                .then(async (firebaseToken) => {
                    console.log('firebaseToken', firebaseToken)
                        this.messengerService.registerToTopic(firebaseToken, 
                            `queue_number_registration_${this.props.configState.outletId}`
                            ).then(
                            () => {
                                onMessage(messaging, (payload: any) => {
                                    console.log(payload)
                                    this.intervalMethod(false);
                                    const firebaseData =  payload?.data;
                                    const lastQueue = payload?.data as LastQueue;
                                    if (firebaseData?.calledBy !== 'pick_queue' && 
                                        ((lastQueue?.lastModified || '') !== 'null')) {
                                            this.checkAndPushToPendingToPlay(lastQueue);
                                    }
                                });
                            },
                            (error) => console.log(error)
                    )
                })
                .catch(error => console.log(error))
            } else {
              console.log('Unable to get permission to notify.')
            }
        })
    }

    closeDialogPermission = () => {
        this.setState({showDialogPermission: false})
    }

    /**
     * 
     * @return {React.ReactElement} return react element
     */
    render() {
        const {
            showDialogPermission,
            listNextQueue,
            listRunningText,
            objectAudios,
            currentPlaying
        } = this.state; 

        return (
            <React.Fragment>
        <Dialog
            open={showDialogPermission}
            onClose={this.closeDialogPermission}
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle>
                Selamat datang di sistem antrian kimia farma.
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    Klik Ok untuk halaman penuh.
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{justifyContent: 'center', display: 'flex'}}>
                <Button onClick={this.playSoundAndFullscreen}>Ok</Button>
            </DialogActions>
        </Dialog>
        <div className='font-barlow h-screen w-screen overflow-auto' id="register-queue">
            <FullScreenPage pageId="register-queue" />
            <div className='h-full w-full px-10 py-4 relative bg-[#F9FAFF]' 
                style={{paddingTop: '3rem',paddingLeft: '6.2rem', paddingRight: '5.7rem',
                backgroundImage: `url(${patternBackground})`, backgroundSize: "auto", 
                backgroundRepeat: "repeat"}}>
                <div className='w-full flex md:gap-x-10 justify-between'>
                    <div className='flex justify-between flex-col'>
                        <div className='flex flex-col w-min min-w-[19em]' style={{width: '48rem'}}>
                            <div className='text-[4rem] text-[#3A3A3C] font-extrabold text-center font m-2 mb-4'
                                style={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    alignItems: 'start',
                                    paddingTop: '0px',
                                    marginLeft: '0px',
                                    marginTop: '-14px',
                                    letterSpacing: '1px'
                                }}>
                                ANTRIAN PENDAFTARAN
                            </div>
                            <div className='rounded-md bg-[#003A78] p-4 current-queue'
                                style={{ marginTop: '0.7rem', height: '31.6rem',
                                    paddingLeft: '2.2rem', paddingRight: '2.2rem',
                                    borderRadius: '2rem'}}>
                                <div className='font-semibold text-4xl text-white text-center mb-4'
                                    style={{
                                        height: '6.4rem',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        fontSize: '3.2rem'
                                    }}>
                                        
                                    Antrian Saat Ini
                                </div>
                                <div className='bg-[#E4E6F8] rounded-md flex flex-row p-5 justify-evenly items-center'
                                    style={{height: '21.3rem', borderRadius: '2rem'}}>
                                    <InfoCounterNumber title="No. Antrian" 
                                        counter={currentPlaying?.counterNumber || '-'} />
                                    <InfoCounterNumber title={' '} counter={
                                        (<div className='font-bold text-base text-[#3A3A3C] text'>
                                            <KeyboardDoubleArrowRight classes={{ root: 'double-arrow-icon' }} />
                                        </div>)
                                    } />
                                    <InfoCounterNumber title="Loket" 
                                        counter={currentPlaying?.counterName || '-'} />
                                </div>
                            </div>
                        </div>
                        <div className='bg-[#EDEEFA] text-4xl font-semibold text-[#4751AB] next-queue-text p-4'
                            style={{
                                height: '8rem',
                                display: 'flex',
                                justifyContent: 'start',
                                alignItems: 'center',
                                paddingLeft: '3rem',
                                fontSize: '3rem',
                            }}>
                            Antrian Selanjutnya
                        </div>
                    </div>
                    <div className='flex flex-col' style={{width: "70rem", marginBottom: '2rem'}}>
                        <div className=' w-full flex flex-row justify-between items-center' 
                            style={{marginBottom: '1.8rem'}}>
                            <div>
                                <img src={kfIconGroup} alt="" style={{
                                    height: '7rem',
                                    position: 'absolute',
                                    top: '1.5rem'
                                }}/>
                            </div>
                            <div className='flex gap-4'>
                                <div className='flex flex-col items-end font-semibold text-3xl'>
                                    <Moment locale="id" interval={30_000} format="dddd"></Moment>
                                    <Moment locale="id" interval={30_000} format="DD MMMM YYYY"></Moment>
                                </div>
                                <div className='bg-[#B8B9C6] w-[1px] my-1' />
                                <div className='text-[#4A57CD] text-7xl font-semibold'>
                                    <Moment interval={1000} format="HH:mm"></Moment>
                                </div>
                            </div>
                        </div>
                        <div className="pb-9 pt-3 h-20em">
                            <div className='aspect-video bg-black rounded-3xl'>
                                <div id="video-player" style={{borderRadius: '1.5rem', width: '100%', height: '100%'}} >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'flex justify-start bg-[#EDEEFA] gap-6 p-4 list-next-queue'} 
                    style={{height: '15rem'}}>
                    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} alignItems={'center'}>
                        {listNextQueue.map(item => 
                            <Grid key={item.counterNumber} item xs={2}>
                                <div key={item.counterNumber} 
                                    className='flex flex-col justify-center items-center next-queue-item'>
                                    <span className='font-bold text-9xl text-[#3A3A3C]'>
                                        {item.counterNumber}
                                    </span>
                                </div>
                            </Grid>
                        )}
                    </Grid>
                </div>

            </div>
            <div className='w-screen bg-[#003A78] absolute bottom-0 text-white text-3xl font-bold
                py-1 gap-6'
                style={{
                    height: '4.6rem',
                    alignItems: 'center',
                    fontSize: '1.8rem',
                    display: 'flex',
                }}>
                    <Marquee className="running-text" direction="left" 
                        speed={30} gradient={false}>
                        {(listRunningText || []).map(item => 
                            item.status && (
                                <div key={item.id}>
                                    {item.text}
                                </div>
                            )
                        )}
                    </Marquee>
            </div>
            <div style={{display: "none"}}>
                {Object.keys(objectAudios || []).map( (key) => 
                    <audio key={key} id={key} src={objectAudios[key]}>
                    </audio>)
                }
            </div>
        </div>
        </React.Fragment>
        )
    }
}
export default  connect(mapStateToProps)(RegisterQueue);